"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetGlobalState = exports.assertIsWebSocket = void 0;
var globals_1 = require("./globals");
var manage_subscribers_1 = require("./manage-subscribers");
function assertIsWebSocket(webSocketInstance) {
    if (webSocketInstance instanceof WebSocket === false)
        throw new Error('');
}
exports.assertIsWebSocket = assertIsWebSocket;
;
function resetGlobalState(url) {
    manage_subscribers_1.resetSubscribers(url);
    globals_1.resetWebSockets(url);
}
exports.resetGlobalState = resetGlobalState;
;
//# sourceMappingURL=util.js.map